import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { ColumnConfigItemEntity } from '../../domain/column-config-item.entity';
import { ColumnConfigListEntity } from '../../domain/column-config-list.entity';

@Injectable()
export class ColumnListProvider {
	private columnList!: ColumnConfigListEntity;

	public constructor() {}

	public createList(isInViewMode: boolean, isInModelConfigMode: boolean): void {
		this.columnList = ColumnConfigListEntity.build([
			{
				field: 'columnType',
				alias: '',
				type: '',
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 0,
			},
			{
				field: 'label',
				alias: $localize`:@@subscription.columns.config.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				visibleIndex: isInViewMode ? 2 : 1,
			},
			{
				field: 'alias',
				alias: isInModelConfigMode
					? $localize`:@@subscription.columns.config.list.column.subscriptionLabel:`
					: $localize`:@@subscription.columns.config.list.column.alias:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				visibleIndex: isInViewMode ? 1 : 2,
			},
			{
				field: 'description',
				alias: $localize`:@@subscription.columns.config.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				visibleIndex: 3,
			},
			{
				field: 'isSelectedInSource',
				alias: $localize`:@@subscription.columns.config.list.column.selectedInSource:`,
				type: 'boolean',
				isSearchable: false,
				isFilterable: true,
				visibleIndex: 4,
			},
			{
				field: 'isActive',
				alias: $localize`:@@subscription.columns.config.list.column.active:`,
				type: 'boolean',
				isSearchable: false,
				isFilterable: true,
				visibleIndex: 5,
			},
			{
				field: 'isHashed',
				alias: $localize`:@@subscription.columns.config.list.column.hashable:`,
				type: 'boolean',
				isSearchable: false,
				isFilterable: true,
				visibleIndex: 6,
			},
			{
				field: 'referencedBy',
				alias: $localize`:@@subscription.columns.config.list.column.usages:`,
				type: '',
				isSearchable: false,
				isFilterable: true,
				visibleIndex: 7,
			},
			{
				field: 'isDeleted',
				alias: $localize`:@@subscription.columns.config.list.column.deleted:`,
				type: 'boolean',
				isSearchable: false,
				isFilterable: true,
				visibleIndex: 8,
			},
		]);
	}

	public getList(): ColumnConfigListEntity {
		return this.columnList;
	}

	public setListElements(
		elements: Map<string, ColumnConfigItemEntity>
	): ColumnConfigListEntity {
		return this.columnList.setElements(elements);
	}
}
